import { memo } from 'react'

import { BrushIcon, EditIcon, PiggyBankIcon, ShopIcon, Text } from '@cash-me/react-components'

import { Grid, Col } from 'components/grid'

import * as S from './styles'

const Solutions = memo(() => (
  <S.Solutions>
    <Grid col={{ phone: 1, tablet: 4, desktop: 12 }}>
      <Col start={{ desktop: 2 }} col={{ tablet: 1, desktop: 4 }}>
        <S.TextWrapper>
          <Text as="h2" size="heading2" weight="medium">
            Empréstimo Online {' '}
            <Text as="span" size="heading2" color="var(--colors-pink-text-default)" weight="medium">
              com garantia de imóvel
            </Text>
          </Text>
          <Text size="body1">
            A CashMe tem soluções que impulsionam seus objetivos, conheça algumas:
          </Text>
        </S.TextWrapper>
      </Col>
      <Col col={{ tablet: 3, desktop: 6 }}>
        <S.SolutionsWrapper>
          <S.Option>
            <S.IconWrapper>
              <ShopIcon size={28} color="var(--colors-cyan-icon-default)" />
            </S.IconWrapper>
            <Text>Investir no seu negócio</Text>
          </S.Option>
          <S.Option>
            <S.IconWrapper>
              <PiggyBankIcon size={28} color="var(--colors-cyan-icon-default)" />
            </S.IconWrapper>
            <Text>Organizar dívidas</Text>
          </S.Option>
          <S.Option>
            <S.IconWrapper>
              <BrushIcon size={28} color="var(--colors-cyan-icon-default)" />
            </S.IconWrapper>
            <Text>Reformar seu imóvel</Text>
          </S.Option>
          <S.Option>
            <S.IconWrapper>
              <EditIcon size={28} color="var(--colors-cyan-icon-default)" />
            </S.IconWrapper>
            <Text>Planejar seu futuro</Text>
          </S.Option>
        </S.SolutionsWrapper>
      </Col>
    </Grid>
  </S.Solutions>
))

Solutions.displayName = 'Solutions'

export default Solutions
